import './Testimonials.scss';
import { $, SlickSlider } from "../../../common/scripts/Libs";

class Testimonials {

  constructor(node) {
    this.node = node;
  }

  init() {
    $(this.node).find('.Testimonials__reviews--slider').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      adaptiveHeight: true,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: false
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true
          }
        }
      ]
    }, SlickSlider);
  }

}

JSModules['Testimonials'] = Testimonials;
export default Testimonials;
